const customerId = $(".customer-profile").data("customerid");
const hash = $(".customer-profile").data("customer-hash");
const sendAt = $(".customer-profile").data("customer-sendat");
var totalPoints = 0;
$(document).ready(function () {
  onLoad();
});

function onLoad(avatarEmail) {
  if (customerId && hash && sendAt) {
    startLoading();
    $.post("/apps/api/getcustomer", JSON.stringify({ customerId, hash, sendAt, avatarEmail }))
      .done(function (data) {
        init(data);
      })
      .fail(function (error) {
        $("#errorModal").modal('show');
      })
      .always(function () {
        finishedLoading();
      });
  }
}

function loadCustomer(avatarEmail) {
  onLoad(avatarEmail);
}

function init(data) {
  totalPoints = data.totalPoints
  $(".rewards-points").text(data.totalPoints);
  if (data.rewards.some(r => r.rewardName === 'Sign up')) {
    $(".earn-container .sign-up-container a").attr("data-reward-earned", "1");
  }
  if (data.rewards.some(r => r.rewardName === 'Review on Google')) {
    $(".earn-container .google-review-container a").attr("data-reward-earned", "1");
  }
  if (data.rewards.some(r => r.rewardName === 'Follow on Instagram')) {
    $(".earn-container .follow-instagram-container a").attr("data-reward-earned", "1");
  }
  if (data.rewards.some(r => r.rewardName === 'Celebrate milestone')) {
    $(".earn-container .milestone-container a").attr("data-reward-earned", "1");
  };
  if (data.vouchers.filter(x => !x.isUsed).length > 0) {
    $(".voucher-container .voucher-list").html("");
    $(".voucher-container").removeClass("d-none");
    data.vouchers.forEach(function (item, index) {
      if (!item.isUsed) {
        $(".voucher-container .voucher-list").append(
          '<div class="col">' +
          '<div class="coupon p-3 bg-white shadow">' +
          '<div class="row no-gutters">' +
          '<div class="col-4 value-container my-auto" style="border-right: 2px dotted grey;">' +
          '<div class="d-flex flex-column align-items-center">' +
          `<p class="h1 value">${item.value}</p><span>OFF</span>` +
          '</div>' +
          '</div>' +
          '<div class="col-8 code-container">' +
          '<div class="d-flex flex-column justify-content-between off px-3 p-2">' +
          '<span class="d-flex">Discount code:</span>' +
          `<p class="h1 d-flex code">${item.discountCode}</p>` +
          '</div>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '</div>');
      }
    });
  } else {
    $(".voucher-container").addClass("d-none");
  };

  if (data.rewards.length > 0) {
    $(".history-container .history-list").html("");
    data.rewards.forEach(function (item, index) {
      var badge = '';
      if (item.points < 0) {
        badge = `<p class="h5 my-auto" style="font-size: initial;"><span class="badge bg-danger rounded-pill item-point">${item.points} Points</span></p>`;
      } else {
        badge = `<p class="h5 my-auto" style="font-size: initial;"><span class="badge bg-success rounded-pill item-point">+${item.points} Points</span></p>`;
      }
      $(".history-container .history-list").append('<li class="list-group-item d-flex justify-content-between align-items-start">' +
        '<div class="ms-2 me-auto">' +
        `<div class="fw-bold item-name">${item.rewardName}</div>` +
        `<span class="item-date">${item.dateTime}</span>` +
        '</div>' +
        badge +
        '</li>');
    });
  }
}

function earn(event) {
  event.preventDefault();
  const rewardEarned = event.currentTarget.dataset.rewardEarned;
  if (rewardEarned === "0") {
    const rewardType = event.currentTarget.dataset.rewardTypeId;
    const rewardHref = event.currentTarget.dataset.rewardHref;
    if (customerId && hash && sendAt && rewardType) {
      if (rewardHref) {
        if (rewardHref.includes("outdo.co.nz")) {
          window.open(rewardHref, '_self').focus();
        } else {
          window.open(rewardHref, '_blank').focus();
        };
      };
      $.post("/apps/api/earn", JSON.stringify({ customerId, hash, sendAt, rewardType }))
        .done(function (data) {
          init(data);
        })
        .fail(function (error) {
          $("#errorModal").modal('show');
        })
        .always(function () {
          finishedLoading();
        });
    } else {
      $("#loginModal").modal('show');
    }
  } else {
    $("#earnedModal").modal('show');
  }
}

function redeem(event) {
  event.preventDefault();
  const voucherTypeId = event.currentTarget.dataset.voucherTypeId;
  if (customerId && hash && sendAt && voucherTypeId) {
    const voucherAmount = event.currentTarget.dataset.voucherAmount;
    const voucherPoint = event.currentTarget.dataset.voucherPoint;
    if (totalPoints >= voucherPoint) {
      $("#confirmModal .confirm .continue").attr("data-voucher-type-id", voucherTypeId);
      $("#confirmModal .voucher-point").text(voucherPoint);
      $("#confirmModal .voucher-amount").text(voucherAmount);
      $("#confirmModal").modal('show');
    }
    else {
      $("#invalidModal .voucher-point").text(voucherPoint);
      $("#invalidModal .total-point").text(totalPoints);
      $("#invalidModal").modal('show');
    }
  } else {
    $("#loginModal").modal('show');
  }
}

function confirmRedeem(event) {
  $("#confirmModal").modal('hide');
  const voucherTypeId = event.currentTarget.dataset.voucherTypeId;
  if (customerId && hash && sendAt && voucherTypeId) {
    startLoading();
    $.post("/apps/api/redeem", JSON.stringify({ customerId, hash, sendAt, voucherTypeId }))
      .done(function (data) {
        init(data);
      })
      .fail(function (error) {
        $("#errorModal").modal('show');
      })
      .always(function () {
        finishedLoading();
      });
  } else {
    $("#loginModal").modal('show');
  }
}

function startLoading() {
  $(".reward-main-container").css("opacity", "0.3");
  $(".spanner").removeClass("d-none");
}

function finishedLoading() {
  $(".reward-main-container").css("opacity", "");
  $(".spanner").addClass("d-none");
}